export default () =>
  (window.navigator.userAgent.includes('iPhone') ||
    window.navigator.userAgent.includes('Safari')) &&
  window.navigator.vendor.includes('Apple')
